const filterLayersByTags = (layers, tags, shouldIncludeTags = false) =>
    layers && layers.filter((layer) =>
        shouldIncludeTags ? tags.includes(layer.tag) : !tags.includes(layer.tag));

module.exports = filterLayersByTags;
